export const SubwalletJS = () => (
  <svg
    fill="none"
    viewBox="0 0 16 24"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8 8.71982V5.79499L2.81557 0L0 1.24374V11.4943L9.74516 15.8269L4.49671 18.1367V15.8269L2.28253 14.8292L0 15.8269V22.7973L2.69256 24L15.8 18.1503V13.7631L4.34637 8.66515V6.01367L13.1211 9.92255L15.8 8.71982Z"
      fill="currentColor"
    ></path>
  </svg>
);

export default SubwalletJS;
